module.exports = __webpack_public_path__ + "static/media/textile_cad_02.085e542e.jpg";